import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

const useHook = () => {
  return useQuery('categories', async () => {
    const response = await service.get('/categories');
    return response.data.data;
  });
};

export default useHook;
